import { SVGProps } from 'react';

export const BlueonionIcon = (props: SVGProps<SVGSVGElement>) => {
  const css =
    '.cls-1{fill:#fff}.cls-2{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:2px}.cls-3{fill:#3783a4}.cls-4{fill:#a6b8c6}.cls-5{fill:#2163af}.cls-6{fill:#e6e4f2}';
  return (
    <img
      // src="../NXMap-white-blue.png"
      src="../evercomm/NXMap-white.png"
      alt="Evercomm"
      style={{ width: props?.width || 130, height: props?.height || 50 }}
    />
  );
};
